import { DirectoryGroupUpdates } from "./DirectoryGroupUpdates";
export class DirectoryGroupUpdateRequest {

    constructor(groupUpdates: DirectoryGroupUpdates[]) {
        this.groupUpdates = groupUpdates;
    }

    groupUpdates: DirectoryGroupUpdates[] = [];
}